import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
export default (function (props) {
  var value = props.value,
    setValue = props.setValue,
    readonly = props.readonly,
    customProps = props.customProps,
    dateFormat = props.dateFormat,
    valueFormat = props.valueFormat,
    placeholder = props.placeholder;
  var formatSingleValue = function formatSingleValue(value) {
    return value && value.isValid() ? value.format(valueFormat) : undefined;
  };
  var handleChange = function handleChange(value) {
    setValue(formatSingleValue(value));
  };
  var renderInput = function renderInput(params) {
    return /*#__PURE__*/React.createElement(TextField, _extends({
      size: "small",
      variant: "standard"
    }, params));
  };
  var desktopModeMediaQuery = "@media (pointer: fine), (pointer: none)";
  return /*#__PURE__*/React.createElement(FormControl, null, /*#__PURE__*/React.createElement(DatePicker, _extends({
    desktopModeMediaQuery: desktopModeMediaQuery,
    readOnly: readonly,
    disabled: readonly,
    toolbarPlaceholder: !readonly ? placeholder : "",
    inputFormat: dateFormat,
    value: value || null,
    onChange: handleChange,
    renderInput: renderInput
  }, customProps)));
});